module.exports = __webpack_public_path__ + "img/92.10.pH.0aae1ab3.png";